module.exports = "varying vec2 vUv;\r\n\r\nvoid main() {\r\n\tvUv = uv;\r\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0 );\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/floor_vert.glsl
// module id = 12
// module chunks = 0